import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { cn } from "@-/com.npmjs.cn";
import { Pressable, View } from "@-/com.npmjs.react-native";
import * as React from "react";
import { Input, type InputProps } from "#input";

export type PasswordInputProps = Omit<InputProps, "secureTextEntry">;

/**
 * Password field with a reveal/hide toggle overlaid on the inside right of the
 * textbox (eye icon when masked, eye-off when shown).
 */
export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  return (
    <View className="relative w-full min-w-0">
      <Input {...props} className={cn("pr-10", className)} secureTextEntry={!passwordVisible} />
      <Pressable
        accessibilityLabel={passwordVisible ? "Hide password" : "Show password"}
        accessibilityRole="button"
        className="absolute inset-y-0 right-0 aspect-square items-center justify-center"
        hitSlop={8}
        onPress={() => {
          setPasswordVisible((visible) => !visible);
        }}
      >
        <Icon
          className="text-muted-foreground"
          name={passwordVisible ? "LuEyeOff" : "LuEye"}
          size={18}
        />
      </Pressable>
    </View>
  );
}
